import { render, staticRenderFns } from "./data-india-hongkong.vue?vue&type=template&id=258a5f14&scoped=true"
import script from "./data-india-hongkong.vue?vue&type=script&lang=js"
export * from "./data-india-hongkong.vue?vue&type=script&lang=js"
import style0 from "./data-india-hongkong.vue?vue&type=style&index=0&id=258a5f14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258a5f14",
  null
  
)

export default component.exports